import {useAuth} from './Auth'

export function useHasModule(slug: string): boolean {
  const {currentUser} = useAuth()

  return !!currentUser?.instance?.plan?.modules?.some(
    (module) => module.slug_name === slug && module.pivot?.active
  )
}
